import vClassification from './Interface/Classification.vue';
import vInterfaceDetails from './Interface/InderfaceDetails.vue';
export default {
  components: {
    vClassification,
    vInterfaceDetails
  },
  props: {
    _groupCode: [Array, String],
    _id: String,
    contentData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    // 加入接口意向单
    addOrderList({
      product_code,
      product_type
    }) {
      this.$emit('addOrderList', {
        product_code,
        product_type
      });
    }
  },
  watch: {
    _id: {
      handler(val) {
        // console.log(val, 'ppp');
      },
      immediate: true
    }
  },
  mounted() {},
  beforeDestroy() {}
};